import type { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  /** sm = p-3, md = p-4, lg = p-6. Default: md */
  padding?: 'sm' | 'md' | 'lg';
  className?: string;
}

const paddingClasses = {
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-6',
} as const;

export default function Card({ children, padding = 'md', className = '' }: CardProps) {
  return (
    <div className={`bg-white dark:bg-gray-800 rounded-xl shadow-lg ${paddingClasses[padding]} ${className}`}>
      {children}
    </div>
  );
}
